import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Services from './components/services/Services';
import Project from './components/portfolio/Project';
import NotFound from './pages/notFound/notFound';
import HomePage from './HomePage';
import ProjectDetails from './components/portfolio/ProjectDetails';
import { TranslationProvider } from './contexts/TranslationContext';
import TransitionOverlay from './components/portfolio/TransitionOverlay';
import { setupViewportHeight } from './utils/viewportHeight';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    // Si c'est une ancre (hash), on scroll vers l'élément
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 0);
      return;
    }

    // Sinon, on scroll tout en haut
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

const App = () => {
  const [isMusicPlaying, setIsMusicPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);

  React.useEffect(() => {
    // Désactiver la restauration automatique du scroll
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  React.useEffect(() => {
    // Initialiser la hauteur du viewport
    const cleanup = setupViewportHeight();
    return cleanup;
  }, []);

  React.useEffect(() => {
    if (showOverlay) {
      const timer = setTimeout(() => {
        setShowOverlay(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showOverlay]);

  const toggleMusic = (track) => {
    if (currentTrack === track) {
      setIsMusicPlaying(!isMusicPlaying);
    } else {
      setCurrentTrack(track);
      setIsMusicPlaying(true);
    }
  };

  return (
    <TranslationProvider>
        <BrowserRouter>
          <ScrollToTop />
          <TransitionOverlay isVisible={showOverlay} />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header isMusicPlaying={isMusicPlaying} toggleMusic={toggleMusic} />
                  <HomePage />
                  <Footer />
                </>
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/project" element={<Project />} />
            <Route path="/project/:projectId" element={<ProjectDetails setShowOverlay={setShowOverlay} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
    </TranslationProvider>
  );
};

export default App;